module.exports = __webpack_public_path__ + "static/media/lab_background.832c0368.jpg";